import { createContext } from 'react'

export interface ErrorsContextType {
  handleError: any
}

export const ErrorsContext = createContext<ErrorsContextType>(undefined!)
